/** Utah's words for schedule.ts: the food handler permit finding. */
export const SCHEDULE_UT = {
  /** When the food handler permit is due (Utah: county permit within 30 days of starting; Utah Code 26B-7-413). */
  permitDueDetail: "Utah requires the permit within 30 days of starting.",
  /** The state's list of approved food handler courses, sent to the person (Utah: the state health department's list). */
  courseListUrl: "https://epi.utah.gov/wp-content/uploads/foodHandler_list.pdf",
} as const;
